import { Avatar, Divider, Dropdown, Menu, Popconfirm, Space } from "antd";
import { DownCircleOutlined, LogoutOutlined } from "@ant-design/icons";
import ChangePwdMenuItemfrom from "../components/common/changepwd";
import { getUser, loginout } from "../states/user/user.reducer";
import { useNavigate, Outlet } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { useLocation } from "react-router";
import Logo from "../assets/logo.png";
import React from "react";

type IProps = {};

const Index: React.FC<IProps> = () => {
  const Navigate = useNavigate();
  const User = useSelector(getUser);
  
  const dispatch = useDispatch();
  const location = useLocation();
  const { pathname } = location;

  React.useEffect(() => {
    if (User === null) {
      Navigate("/login");
    } else {
      if (pathname === "/") Navigate("/dashbord");
    }
  }, [User, Navigate, pathname]);

  React.useEffect(() => {
    document.title = "拖车侠企业服务平台";
  }, []);

  if (User === null) {
    Navigate("/login");
    return <div></div>;
  }

  return (
    <div className="flex flex-column min-height-100vh background-color-d9d9d9">
      <div className="flex-1">
        <div className="height-48px padding-left-16px padding-right-16px background-color-1890ff text-right line-height-48px font-color-ffffff">
          <div
            className="font-color-ffffff flex"
            style={{ justifyContent: "space-between" }}
          >
            <Space className="text-left">
              <Avatar shape="square" src={Logo} />
              <div>数字救援&nbsp;&nbsp;&nbsp;智慧可见</div>
            </Space>
            <Space className="text-right ">
              <div>{User.companyName || ""}</div>
              <Divider type="horizontal" />

              <Divider type="horizontal" />
              <div style={{ display: "inline-block" }}>
                <Dropdown
                  menu={{
                    items: [
                      {
                        key: "menu-draw",
                        label: (
                          <Menu key="u">
                            <ChangePwdMenuItemfrom
                              logout={() => dispatch(loginout())}
                            />
                            <Menu.Divider key="md" />
                            <Popconfirm
                              title="确定退出？"
                              onConfirm={() => {
                                dispatch(loginout());
                              }}
                            >
                              <Menu.Item key="out" icon={<LogoutOutlined />}>
                                <span>退出</span>
                              </Menu.Item>
                            </Popconfirm>
                          </Menu>
                        ),
                      },
                    ],
                  }}
                >
                  <div>
                    <Avatar src={Logo} />
                    <span style={{ marginLeft: "8px" }}>
                      {User?.name} <DownCircleOutlined size={4} />
                    </span>
                  </div>
                </Dropdown>
              </div>
            </Space>
          </div>
        </div>

        {/* <div className="flex padding-left-16px padding-right-16px"> */}
        {/* <div
            className="width-100px background-color-fff margin-top-40px margin-bottom-40px box-shadow-1 border-radius-4px flex flex-column text-center background-color-ffffff"
            style={{ minHeight: "calc(100vh - 80px - 96px)" }}
          >
            <div className="flex-1">{routeDom}</div>
            <div className="margin-top-32px">
              <div
                style={{
                  height: "1px",
                  width: "100%",
                  backgroundColor: "rgba(224,224,224,0.5)",
                }}
              />
              <div className="flex flex-center margin-top-32px margin-bottom-32px">
                <Link to="/">
                  <Tooltip color="#1e90ff" title="个人中心" placement="right">
                    <UserOutlined
                      color="#1E90FF"
                      className="font-size-32px font-color-1e90ff"
                    />
                  </Tooltip>
                </Link>
              </div>
            </div>
          </div> */}
        {/* <div className="margin-top-40px margin-bottom-40px box-shadow-1 border-radius-4px flex-1 margin-left-16px margin-right-6px padding-32px background-color-ffffff width-640px"> */}
        {/* <Outlet /> */}
        {/* </div> */}
        {/* <div>
            <Messager />
          </div> */}
        {/* <div className="margin-top-40px margin-bottom-40px box-shadow-1 border-radius-4px width-400px">
            <Messager />
          </div> */}
        {/* </div> */}
        <div className="margin-16px box-shadow-1 border-radius-4px flex-1 padding-16px background-color-ffffff">
          <Outlet />
        </div>
      </div>
      <div className="height-48px text-center line-height-48px width-100p background-color-1890ff font-color-ffffff">
        贵州拖车侠科技服务有限公司 &copy; 2017-{new Date().getFullYear()}{" "}
        &spades; renshan&#64;2155.io
      </div>
    </div>
  );
};

export default Index;
